import React from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth'
import TelegramLoginButton from '../components/TelegramLoginButton'
import { TelegramAuthData } from '../api/auth'

const LoginPage: React.FC = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { login, isAuthenticated, isLoading } = useAuth()

  // Get return URL from location state
  const from = (location.state as { from?: Location })?.from?.pathname || '/dashboard'

  // If already authenticated, redirect
  React.useEffect(() => {
    if (isAuthenticated && !isLoading) {
      navigate(from, { replace: true })
    }
  }, [isAuthenticated, isLoading, navigate, from])

  const handleTelegramAuth = async (data: TelegramAuthData) => {
    try {
      await login(data)
      navigate(from, { replace: true })
    } catch (error) {
      console.error('Login failed:', error)
    }
  }

  // Get bot name from environment or use default
  const botName = 'Fluffy_Fox_Ear_Bot' // This should match your Telegram bot username

  return (
    <div className="min-h-screen bg-gradient-to-b from-orange-50 to-white flex flex-col items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-xl p-8 text-center">
        {/* Logo */}
        <div className="mb-6">
          <img
            src="/images/logo-512.png"
            alt="Fox Ear"
            className="w-24 h-24 mx-auto"
          />
        </div>

        {/* Title */}
        <h1 className="text-2xl font-bold text-gray-900 mb-2">
          Fluffy Fox Ear
        </h1>
        <p className="text-gray-600 mb-8">
          Войдите через Telegram для доступа к вашим проектам
        </p>

        {/* Telegram Login Button */}
        {isLoading ? (
          <div className="flex justify-center">
            <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-orange-500"></div>
          </div>
        ) : (
          <div className="flex justify-center">
            <TelegramLoginButton
              botName={botName}
              onAuth={handleTelegramAuth}
              buttonSize="large"
              cornerRadius={10}
            />
          </div>
        )}

        {/* Info */}
        <p className="text-sm text-gray-500 mt-8">
          Используйте тот же аккаунт Telegram, с которого вы общаетесь с ботом
        </p>
      </div>

      {/* Footer link */}
      <a
        href="/"
        className="mt-8 text-orange-600 hover:text-orange-700 text-sm"
      >
        &larr; На главную
      </a>
    </div>
  )
}

export default LoginPage
